<template>
  <div class="auth">
    <div class="auth-logo my-5">
      <img src="@/assets/2-1.png" />
    </div>
    <div class="auth-container">
      <div class="auth-wrapper px-sm-5 px-4">
        <p class="auth-title">Log In</p>
        <div class="position-relative w-100">
<!--          for email verification -> email: true-->
          <primary-input
                  type="email"
                  name="email"
                  v-validate="{ required: true }"
                  data-vv-as="email"
                  v-model="user_name"
                  @keyup.enter.native="login"
                  class="email-input"
                  :class="{ input: true, 'is-danger': errors.has('email') }"
                  placeholder
          />
          <div class="help is-danger" v-if="errors.has('email')">
            {{ errors.first("email") }}
          </div>
        </div>

        <div class="position-relative w-100">
          <primary-input
                  type="password"
                  name="password"
                  v-model="password"
                  @keyup.enter.native="login"
                  placeholder
                  v-validate="{ required: true, min: 3 }"
                  data-vv-as="password"
                  class="password-input"
                  :class="{ input: true, 'is-danger': errors.has('password') }"
          />
          <div class="help is-danger" v-if="errors.has('password')">
            {{ errors.first("password") }}
          </div>
        </div>

        <div class="auth-nav-container first mb-2">
<!--          <div class="remember-me">-->
<!--            <input type="checkbox" />-->
<!--            <span>Remember me</span>-->
<!--          </div>-->
          <a class="link" @click="$router.push({name: 'forgot-password'})">Forgot password?</a>
        </div>
        <div class="auth-nav-container mt-3">
          <primary-button @click.native="login" class="mr-2 my-2 white_space">Log In</primary-button>
          <span>
            Don't have an account?
            <a class="link my-2" @click="$router.push({name: 'register'})">Register</a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("../../components/Inputs/PrimaryInput.vue"),
    PrimaryButton: () => import("../../components/Buttons/PrimaryButton.vue"),

  },
  data: () => ({
    user_name: "",
    password: "",
  }),
  methods: {
    login: async function () {
      const valid = await this.$validator.validate();
      if (!valid) {
        return;
      }

      try {
        const { user_name, password } = this;

        if (!user_name) {
          this.$error({
            response: {
              data: { error: { message: "User name field is reqired" } },
            },
          });
          return;
        } else if (!password) {
          this.$error({
            response: {
              data: { error: { message: "Password field is reqired" } },
            },
          });
          return;
        }

        await this.$store.dispatch("auth", { user_name, password });

        this.$store.dispatch("UserGetInfo").then((res) => {
          if (this.$store.getters.isAuthenticated) {
            this.$success("Success");

            const { userType, routePath_email } = this.$store.getters;
            const _email = res.email;

            const { fullPath, email } =
              this.$store.getters.routePath_email || {};

            if (routePath_email && _email === email) {
              this.$router.push(fullPath);
            } else {
              if (userType == "admin") {
                this.$router.push({ name: "system_admin" });
              } else if (userType == "company_admin") {
                this.$router.push({ name: "company_admin" });
              } else if (userType == "user") {
                this.$router.push({ name: "company_user" });
              } else if (userType == "reseller") {
                this.$router.push({ name: "reseller" });
              }
            }

            this.$store.commit("setRoutePath", null);
          }
        });
      } catch (err) {
        this.$error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.auth {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  .auth-container {
    margin-top: -152px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .auth-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 540px;
      border-radius: 4px;
      background-color: #ffffff;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
      padding: 60px;
      margin: 150px auto;
      .auth-title {
        color: #000000;
        font-family: "Helvetica Neue";
        font-size: 24px;
        font-weight: bold;
        line-height: 24px;
        text-align: center;
        margin-bottom: 30px;
      }
      .email-input {
        margin-bottom: 20px;
      }
      .password-input {
        margin-bottom: 20px;
      }
      .auth-nav-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        button {
          width: 90px;
          height: 40px;
        }
        span {
          margin-left: 60px;
          color: #55616e;
          font-family: "Helvetica Neue";
          font-weight: 400;
          font-size: 16px;
          line-height: 20px;
        }
        .link {
          color: #51a3f3;
        }
      }
      .first {
        margin-bottom: 30px;
        .remember-me {
          display: flex;
          align-items: center;
          input {
            margin-right: 5px;
          }
        }
      }
    }
  }
}

  .help {
    position: absolute;
    bottom: 3px;
  }
</style>

